import { IModel } from "@/@types/models/model";

import { coreFields} from "./helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const Fishnet: IModel = {
  title: "Fishnets",
  apiPath: "operations/projekti/{$projekt_id}/fishnets",
  forms : {
    "default": {
      fields: [ "id", "projekt_id", "sifra"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "projekt_id", "sifra"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "Projekt ID",
      source: "projekt_id",
      ttoken: "fishnets.projekt_id",
      type: "wholenum",
      readonly: true
    },
    {
      title: "Šifra",
      source: "sifra",
      ttoken: "projekti.sifra",
      type: "text",
      readonly: true
    },
    commonFields.wkt,
    {
      title: "Count all",
      source: "cnt_all",
      ttoken: "common.cnt_all",
      type: "numeric",
      readonly: true
    },
    {
      title: "Count pregledano",
      source: "cnt_pregledano",
      ttoken: "common.cnt_pregledano",
      type: "numeric",
      readonly: true
    },
    {
      title: "Count nepregledano",
      source: "cnt_nepregledano",
      ttoken: "common.cnt_nepregledano",
      type: "numeric",
      readonly: true
    }
  ]
}

export default Fishnet;
